/**
 * May the signed-in person accept or reject this agent's proposals? One of the
 * agent's review roles, or a workspace administrator (spec §2 G). The database
 * enforces the same rule; this only decides whether the controls are drawn
 * (build contract §2.8: never draw a control the person may not use).
 *
 * Null agent type (a person's own proposal) → true.
 */

import { useEffect, useState } from 'react';
import { agentReviewerAllowed } from '../lib/agentRuntimeService';
import { useUserStore } from '../stores/prioritization/userStore';

export function useAgentReviewerAllowed(workspaceId: string | null | undefined, agentType: string | null | undefined): boolean {
  const userId = useUserStore((s) => s.userId);
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    let live = true;
    if (!agentType) { setAllowed(true); return; }
    if (!workspaceId || !userId) { setAllowed(false); return; }
    void agentReviewerAllowed(workspaceId, agentType, userId).then((ok) => { if (live) setAllowed(ok); });
    return () => { live = false; };
  }, [workspaceId, agentType, userId]);
  return allowed;
}
